// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// ایمپورت صفحات
import Home from './pages/Home.js';
import Utility from './pages/Utility.js';
import Art from './pages/Art.js';
import ArtStudio from './pages/ArtStudio.js';
import About from './pages/About.js';
import Roadmap from './pages/Roadmap.js';
import AIChat from './pages/Aichat.js';
import ImageGeneratorAI from './pages/Imagegenerator.js';
import Setting from './pages/Setting.js';
import LoginRegister from './pages/LoginRegister.js';
import ConfirmEmail from './pages/ConfirmEmail.js';

// ایمپورت صفحات ادمین
import AdminLayout from './components/AdminLayout.js';
import Users from './admin/Users.js';
import Imagerequests from './admin/Imagerequests.js';
import Chatrequests from './admin/Chatrequests.js';

// محافظت از روت‌های ادمین
import ProtectedRoute from './components/ProtectedRoute.js';

import { UserProvider } from "./context/UserContext.js";
import Header from './components/Header.js';
import Footer from './components/Footer.js';

import './App.css';

function App() {
  return (
    <Router>
      <UserProvider>
        <div className="app-container">
          <Header />
          <div className="content-container">
            <Routes>
              {/* مسیرهای عمومی */}
              <Route path="/" element={
                <>
                  <Home />
                  <Footer />
                </>
              } />
              <Route path="/utility" element={
                <>
                  <Utility />
                  <Footer />
                </>
              } />
              <Route path="/roadmap" element={
                <>
                  <Roadmap />
                  <Footer />
                </>
              } />
              <Route path="/art" element={
                <>
                  <Art />
                  <Footer />
                </>
              } />
              <Route path="/artstudio" element={
                <>
                  <ArtStudio />
                  <Footer />
                </>
              } />
              <Route path="/about" element={
                <>
                  <About />
                  <Footer />
                </>
              } />
              <Route path="/chatwhithai" element={
                <>
                  <AIChat />
                  <Footer />
                </>
              } />
              <Route path="/imagegeneratorai" element={
                <>
                  <ImageGeneratorAI />
                  <Footer />
                </>
              } />
              <Route path="/setting" element={
                <>
                  <Setting />
                  <Footer />
                </>
              } />
              <Route path="/login" element={
                <>
                  <LoginRegister />
                  <Footer />
                </>
              } />
              <Route path="/confirm-email" element={
                <>
                  <ConfirmEmail />
                  <Footer />
                </>
              } />

              {/* مسیرهای ادمین */}
              <Route path="/Admin" element={<ProtectedRoute />}>
                <Route element={<AdminLayout />}>
                  <Route index element={<Navigate to="/Admin/users" replace />} />
                  <Route path="users" element={<Users />} />
                  <Route path="chatrequests" element={<Chatrequests />} />
                  <Route path="imagerequests" element={<Imagerequests />} />
                </Route>
              </Route>
            </Routes>
          </div>
        </div>
      </UserProvider>
    </Router>
  );
}

export default App;